import { Link } from "react-router-dom";

export type TabKey = "dashboard" | "routes" | "drivers";

const TABS: ReadonlyArray<{ key: TabKey; label: string; to: string }> = [
  { key: "dashboard", label: "Dashboard", to: "/dashboard" },
  { key: "routes", label: "Routes", to: "/routes" },
  { key: "drivers", label: "Drivers", to: "/drivers" },
];

export function TabsBar({ active }: { active: TabKey }) {
  return (
    <nav style={styles.tabs} aria-label="Primary">
      {TABS.map((t) => {
        const isActive = t.key === active;
        return (
          <Link
            key={t.key}
            to={t.to}
            style={{
              ...styles.tab,
              ...(isActive ? styles.tabActive : null),
            }}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}

const styles: Record<string, React.CSSProperties> = {
  tabs: {
    display: "flex",
    gap: 4,
    marginBottom: 16,
    borderBottom: "1px solid #ddd",
  },
  tab: {
    padding: "8px 14px",
    color: "#666",
    textDecoration: "none",
    fontSize: 14,
    fontWeight: 600,
    borderBottom: "2px solid transparent",
    marginBottom: -1,
  },
  tabActive: {
    color: "#1a3a5c",
    borderBottomColor: "#1a3a5c",
  },
};
